import "core-js/modules/es.array.push.js";
import dayjs from "dayjs";
export default {
  name: "plotDialog",
  data() {
    return {
      soliData: JSON.parse(localStorage.getItem("plotInfo")),
      search_data: {
        queryBeginTime: dayjs().subtract(24, "hour").format("YYYY-MM-DD") + " 00:00:00",
        queryEndTime: dayjs().format("YYYY-MM-DD") + " 23:59:59"
      },
      value: "24",
      number: "",
      // 实时数据
      lastestData: {},
      timeOptions: [{
        value: "24",
        label: "最近24小时"
      }, {
        value: "3",
        label: "最近3天"
      }, {
        value: "7",
        label: "最近7天"
      }],
      dialogVisible: false,
      chartsOption: {
        // 设置曲线的颜色
        color: ["#19E3B4"],
        grid: {
          top: "20%",
          // 顶部留白
          left: "10%",
          // 左侧留白
          right: "10%",
          // 右侧留白
          bottom: "20%" // 底部留白
        },

        legend: {
          top: 10,
          data: ["温度"],
          textStyle: {
            color: "#fff",
            // 设置文字颜色为白色
            fontSize: 9 // 设置文字大小为7px
          }
        },

        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
        },
        yAxis: {
          type: "value"
        },
        // 设置阴影渐变
        series: [{
          name: "温度",
          type: "line",
          data: [0, 220, 332, 301, 334, 390, 330],
          areaStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#19E3B4"
              }, {
                offset: 1,
                color: "rgba(25, 227, 180, 0)"
              }])
            }
          }
        }]
      }
    };
  },
  computed: {
    options() {
      let plotList = JSON.parse(window.localStorage.getItem("plotList"));
      plotList.forEach(el => {
        el.value = el.id;
        el.label = el.name;
      });
      return plotList;
    },
    soilDataComputed() {
      console.log(JSON.parse(localStorage.getItem("plotInfo")), 'soilDatasoilDatasoilData');
      return JSON.parse(localStorage.getItem("plotInfo")).greenhouseVoList[0].soilTemperature + '℃/' + JSON.parse(localStorage.getItem("plotInfo")).greenhouseVoList[0].soilHumidity + '%';
    }
  },
  methods: {
    // 关闭弹窗前触发
    handleClose() {},
    // 打开弹窗
    open(number) {
      this.dialogVisible = true;
      this.number = number;
      this.getWeatherTrendData(number);
    },
    selectChange(e) {
      console.log(e, "eeee");
      if (e == '24') {
        this.search_data.queryBeginTime = dayjs().subtract(24, "hour").format("YYYY-MM-DD") + " 00:00:00";
      }
      if (e == '7') {
        this.search_data.queryBeginTime = dayjs().subtract(7, "day").format("YYYY-MM-DD") + " 00:00:00";
      }
      if (e == '3') {
        this.search_data.queryBeginTime = dayjs().subtract(3, "day").format("YYYY-MM-DD") + " 00:00:00";
      }
      this.getWeatherTrendData(this.number);
    },
    // 打开时触发
    openChange() {
      // this.initChart();
    },
    // 关闭dialog
    closeDialog() {
      this.dialogVisible = false;
    },
    // 获取气象站温度趋势数据
    async getWeatherTrendData(number) {
      let params = {
        number,
        ...this.search_data,
        pageSize: '10000'
      };
      let {
        rows,
        code
      } = await this.$api.getGreenhouseListData(params);
      if (code == "200") {
        this.listData = rows;
        let xData = this.getChartsData(rows, "createTime");
        let soilTempData = this.getChartsData(rows, "soilTemperature");
        let soilHumData = this.getChartsData(rows, "soilHumidity");
        this.initChart(0, xData, soilTempData, soilHumData, ["温度", "湿度"]);
      }
      console.log(rows, "气象站历史数据");
    },
    // 获取不同字段，组成数组
    getChartsData(array, prop) {
      let arr = [];
      for (let i = 0; i < array.length; i++) {
        arr.push(array[i][prop]);
      }
      return arr;
    },
    nullFormatter(val) {
      if (val == null || val == undefined || val == "") {
        return "--";
      } else {
        return val;
      }
    },
    // initChart() {
    //   this.initAirTempChart();
    //   this.initAirHumChart();
    //   this.initCo2Chart();
    //   this.initLightChart();
    //   this.initSoilTempChart();
    //   this.initSoilHumChart();
    // },
    initChart(index, xData, yData1, yData, legendData) {
      console.log(index, xData, yData, legendData, "this.$refs.echarts");
      let airTempDom = this.$refs.airTemp;
      var chartDom = airTempDom;
      if (index == 0) chartDom = airTempDom;
      console.log(chartDom, "chartDom");
      var myChart = this.$echarts.init(chartDom);
      // 定义颜色
      const color = "#19E3B4";

      // 设置阴影渐变
      const areaStyle = {
        normal: {
          color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: color
          }, {
            offset: 1,
            color: "rgba(25, 227, 180, 0)"
          }])
        }
      };

      // 配置项
      const option = {
        // 设置曲线的颜色
        color: ["#19E3B4"],
        grid: {
          top: "20%",
          // 顶部留白
          left: "10%",
          // 左侧留白
          right: "10%",
          // 右侧留白
          bottom: "20%" // 底部留白
        },

        legend: {
          top: 10,
          data: legendData,
          textStyle: {
            color: "#fff",
            // 设置文字颜色为白色
            fontSize: 9 // 设置文字大小为7px
          }
        },

        xAxis: {
          type: "category",
          data: xData
        },
        yAxis: {
          type: "value"
        },
        // 设置阴影渐变
        series: [{
          name: "温度",
          type: "line",
          smooth: true,
          // 线是圆滑的、
          showAllSymbol: true,
          symbolSize: 5,
          showSymbol: false,
          data: yData1,
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 1,
              x2: 0,
              y2: 0,
              colorStops: [{
                offset: 0,
                color: "rgba(34, 255, 204, 0.2)" // 0% 处的颜色
              }, {
                offset: 1,
                color: "rgba(34, 255, 204, 1)" // 100% 处的颜色
              }],

              global: false // 缺省为 false
            }
          },

          lineStyle: {
            color: "#22FFCC"
          }
        }, {
          name: "湿度",
          type: "line",
          smooth: true,
          // 线是圆滑的、
          showAllSymbol: true,
          // symbolSize: 5,
          showSymbol: false,
          data: yData,
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 1,
              x2: 0,
              y2: 0,
              colorStops: [{
                offset: 0,
                color: "rgba(34, 154, 255, 0.2)" // 0% 处的颜色
              }, {
                offset: 1,
                color: "rgba(34, 154, 255, 1)" // 100% 处的颜色
              }],

              global: false // 缺省为 false
            }
          },

          lineStyle: {
            color: "#229AFF"
          }
        }]
      };
      option && myChart.setOption(option);
    },
    // 空气温度chart
    initAirTempChart() {
      var chartDom = this.$refs.airTemp;
      var myChart = this.$echarts.init(chartDom);
      const option = this.chartsOption;
      option && myChart.setOption(option);
    },
    //空气湿度chart
    initAirHumChart() {
      var chartDom = this.$refs.airHum;
      var myChart = this.$echarts.init(chartDom);
      let option = this.chartsOption;
      option.series[0].name = "湿度";
      option.legend.data = ["湿度"];
      option && myChart.setOption(option);
    },
    initCo2Chart() {
      var chartDom = this.$refs.co2;
      var myChart = this.$echarts.init(chartDom);
      let option = this.chartsOption;
      option.series[0].name = "浓度";
      option.legend.data = ["浓度"];
      option && myChart.setOption(option);
    },
    initLightChart() {
      var chartDom = this.$refs.light;
      var myChart = this.$echarts.init(chartDom);
      let option = this.chartsOption;
      option.series[0].name = "光照强度";
      option.legend.data = ["光照强度"];
      option && myChart.setOption(option);
    },
    initSoilTempChart() {
      var chartDom = this.$refs.soilTemp;
      var myChart = this.$echarts.init(chartDom);
      let option = this.chartsOption;
      option.series[0].name = "温度";
      option.legend.data = ["温度"];
      option && myChart.setOption(option);
    },
    initSoilHumChart() {
      var chartDom = this.$refs.soilHum;
      var myChart = this.$echarts.init(chartDom);
      let option = this.chartsOption;
      option.series[0].name = "湿度";
      option.legend.data = ["湿度"];
      option && myChart.setOption(option);
    }
  }
};